import { FeatureCardList } from "@/components/landing/FeatureCardList";
import { LandingVideo } from "@/components/landing/LandingVideo";

// H.264, а не AV1: софтверное декодирование AV1 сильно грузит процессор
const trustVideo = "/videos/landing/trust.mp4";

const CARDS = [
  {
    title: "Прозрачная история сделок",
    text: "Все торговые операции логируются и доступны для анализа в любую секунду.",
  },
  {
    title: "Демо-режим для знакомства",
    text: "Проверьте бота на виртуальном балансе перед подключением реального депозита.",
  },
  {
    title: "Остановка в любой момент",
    text: "Мы не удерживаем ваши средства, вы можете выйти из процесса моментально.",
  },
  {
    title: "Понятная модель комиссии",
    text: "Мы списываем плату только за фактический положительный финансовый результат.",
  },
];

export const TrustSection = () => (
  <section className="border-landing-line border-b">
    <div className="landing-container flex flex-col gap-12 pt-[6.25rem] pb-[7.5rem] max-md:gap-8 max-md:py-20 lg:flex-row">
      <div // basis-0 в колонке даёт нулевую высоту, из-за чего aspect-ratio не срабатывал
        className="relative isolate flex aspect-[496/624] w-full flex-1 basis-0 flex-col justify-end overflow-hidden rounded-2xl bg-neutral-900 p-10 max-lg:aspect-[16/9] max-lg:flex-none max-lg:basis-auto max-md:aspect-[16/10] max-md:p-6"
      >
        <LandingVideo
          className="absolute inset-0 -z-20 h-full w-full object-cover"
          src={trustVideo}
        />
        {/* Угол в Figma -45° (знак обратный CSS). Размываем саму форму, а не фон —
            так края мягкие и видео просвечивает.
            В Figma тут mix-blend-plus-lighter, но режим наложения поверх видео пересчитывается
            на каждый кадр и отключает быстрый видеослой — ролик из-за него спотыкался,
            поэтому накладываем обычной прозрачностью. */}
        <div
          aria-hidden
          className="pointer-events-none absolute top-[5%] left-[71%] -z-10 h-[28.9rem] w-[68.5rem] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded-full opacity-70 blur-[70px] max-md:h-[7rem] max-md:w-[16rem] max-md:opacity-60 max-md:blur-[40px]"
          style={{
            background:
              "linear-gradient(180deg, rgba(253, 233, 0, 0.76) 0%, rgba(198, 253, 0, 0.76) 66%)",
          }}
        />
        <h2 className="text-[3rem] leading-[1.1] font-semibold text-white max-md:text-[1.75rem]">
          Почему я могу
          <br />
          довериться?
        </h2>
      </div>

      <FeatureCardList
        cards={CARDS}
        stretch
        className="flex flex-1 basis-0 flex-col gap-6 max-lg:flex-none max-lg:basis-auto"
      />
    </div>
  </section>
);
